import { render, staticRenderFns } from "./Restaurateur.vue?vue&type=template&id=0295416c&"
import script from "./Restaurateur.vue?vue&type=script&lang=js&"
export * from "./Restaurateur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports